export default __webpack_public_path__ + "static/assets/924ec7c6e8dc295a26a6a724f5b6a9fa.png";